var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7108 11.4818L4.04944 13.9507L1.63217 14.0019C0.909762 12.6619 0.5 11.1289 0.5 9.49982C0.5 7.92449 0.883117 6.43893 1.56222 5.13086H1.56274L3.71479 5.52541L4.65751 7.66454C4.4602 8.23977 4.35266 8.85727 4.35266 9.49982C4.35273 10.1972 4.47905 10.8653 4.7108 11.4818Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3341 7.72559C19.4432 8.30026 19.5001 8.89375 19.5001 9.5003C19.5001 10.1804 19.4286 10.8439 19.2924 11.4838C18.8299 13.6615 17.6215 15.5631 15.9476 16.9087L15.9471 16.9082L13.2364 16.7699L12.8528 14.3751C13.9636 13.7236 14.8316 12.7042 15.2889 11.4838H10.209V7.72559H15.363H19.3341Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9475 16.9084L15.9481 16.9089C14.32 18.2175 12.2519 19.0004 10.0006 19.0004C6.38281 19.0004 3.23738 16.9783 1.63281 14.0025L4.71144 11.4824C5.51371 13.6236 7.57918 15.1478 10.0006 15.1478C11.0415 15.1478 12.0165 14.8664 12.8532 14.3752L15.9475 16.9084Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0641 2.18708L12.9865 4.70666C12.1206 4.16538 11.0969 3.8527 10.0003 3.8527C7.52401 3.8527 5.41991 5.4468 4.65783 7.66472L1.56302 5.13104H1.5625C3.14358 2.08269 6.32868 0 10.0003 0C12.3053 0 14.4188 0.821082 16.0641 2.18708Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.6d90a0a9.svg";
export { ForwardRef as ReactComponent };